import type { Publication } from './publications';

export const johanEstradaPublications: Publication[] = [
  {
    "id": "estrada-009",
    "title": "Analysis and Hardware Architecture on FPGA of a Robust Audio Fingerprinting Method Using SSM",
    "authors": "Ignacio Algredo-Badillo, Brenda Sánchez-Juárez, Kelsey A. Ramírez-Gutiérrez, Claudia Feregrino-Uribe, Francisco López-Huerta, Johan J. Estrada-López",
    "date": "2022-07-01",
    "type": "article",
    "venue": "Technologies (MDPI), vol. 10, no. 4, art. 86",
    "doi": "https://doi.org/10.3390/technologies10040086",
    "abstract": "Análisis y arquitectura hardware en FPGA de un método robusto de huella digital de audio (audio fingerprinting) basado en matrices de autosimilitud (SSM).",
    "publicAccessUrl": "https://www.mdpi.com/2227-7080/10/4/86",
    "pdfUrl": "https://www.mdpi.com/2227-7080/10/4/86/pdf"
  },
  {
    "id": "estrada-011",
    "title": "Skew-Circulant-Matrix-Based Harmonic-Canceling Synthesizer for BIST Applications",
    "authors": "Guillermo G. Garayar-Leyva, Hatem Osman, Johan J. Estrada-López, Oscar Moreira-Tamayo",
    "date": "2022-04-09",
    "type": "article",
    "venue": "Sensors (MDPI), vol. 22, no. 8, art. 2884",
    "doi": "https://doi.org/10.3390/s22082884",
    "abstract": "Generador de tono único para autoprueba integrada (BIST) que filtra armónicos de una onda cuadrada; usa un generador recursivo de coeficientes basado en matrices skew-circulant para reducir la sensibilidad a la precisión. Prototipo CMOS 180 nm: cancela hasta el armónico 47, 0.8–100 MHz, SFDR máx. 66 dB.",
    "tags": [
      "Built-In Self-Test",
      "Harmonic-Canceling Filter",
      "Skew-Circulant Matrix",
      "CMOS",
      "180 nm"
    ],
    "publicAccessUrl": "https://www.mdpi.com/1424-8220/22/8/2884",
    "pdfUrl": "https://www.mdpi.com/1424-8220/22/8/2884/pdf"
  },
  {
    "id": "estrada-015",
    "title": "Design Trade-Offs in Common-Mode Feedback Implementations for Highly Linear Three-Stage Operational Transconductance Amplifiers",
    "authors": "Joseph Riad, Sergio Soto-Aguilar, Johan J. Estrada-López, Oscar Moreira-Tamayo, Edgar Sánchez-Sinencio",
    "date": "2021-04-21",
    "type": "article",
    "venue": "Electronics (MDPI), vol. 10, no. 9, art. 991",
    "doi": "https://doi.org/10.3390/electronics10090991",
    "abstract": "Compara arreglos de retroalimentación de modo común (CMFB) de un solo lazo y de múltiples lazos en OTAs de tres etapas, evaluando estabilidad, linealidad, ruido y rechazo de modo común. El esquema multilazo resulta superior, con +6 dB en P1dB en un filtro activo-RC.",
    "tags": [
      "common-mode feedback",
      "common-mode rejection",
      "linearity",
      "three-stage OTA",
      "stability",
      "noise",
      "active filter"
    ],
    "publicAccessUrl": "https://www.mdpi.com/2079-9292/10/9/991",
    "pdfUrl": "https://www.mdpi.com/2079-9292/10/9/991/pdf"
  },
  {
    "id": "estrada-016",
    "title": "A CMOS Energy Harvesting Interface Circuit With Cycle-to-Cycle Frequency-to-Amplitude Conversion MPPT for Centimeter-Scale Wind Turbine",
    "authors": "Zizhen Zeng, Johan J. Estrada-López, Bo Wang, Edgar Sánchez-Sinencio",
    "date": "2021-09-01",
    "type": "article",
    "venue": "IEEE Transactions on Circuits and Systems I: Regular Papers, vol. 68, no. 9, pp. 3587–3597",
    "doi": "https://doi.org/10.1109/TCSI.2021.3087790",
    "abstract": "Circuito integrado para cosechar energía de una microturbina eólica electromagnética de escala centimétrica: rectificador activo autopolarizado, convertidor boost con calibración de conmutación a corriente cero (93.3% de eficiencia DC-DC) y un MPPT por conversión frecuencia-amplitud que rastrea el punto óptimo ciclo a ciclo (eficiencia MPPT 99.85%, extremo a extremo 88.2%)."
  },
  {
    "id": "estrada-018",
    "title": "Gaussian-Process-Based Surrogate for Optimization-Aided and Process-Variations-Aware Analog Circuit Design",
    "authors": "Adriana C. Sanabria-Borbón, Sergio Soto-Aguilar, Johan J. Estrada-López, Douglas Allaire, Edgar Sánchez-Sinencio",
    "date": "2020-04-23",
    "type": "article",
    "venue": "Electronics (MDPI), vol. 9, no. 4, art. 685",
    "doi": "https://doi.org/10.3390/electronics9040685",
    "abstract": "Modelo sustituto de bajo costo para diseño analógico automatizado con optimización multiobjetivo, que combina regresión por procesos gaussianos de parámetros tecnológicos, un modelo MOSFET físico y ecuaciones de desempeño. Evalúa diseños entre 69 y 470 veces más rápido que la simulación de circuitos.",
    "tags": [
      "surrogate model",
      "optimization algorithms",
      "analog integrated circuit design",
      "Gaussian process regression",
      "process variations",
      "physics-based MOSFET model",
      "inversion level",
      "Pareto front",
      "active filters",
      "voltage regulators",
      "oscillators"
    ],
    "publicAccessUrl": "https://www.mdpi.com/2079-9292/9/4/685",
    "pdfUrl": "https://www.mdpi.com/2079-9292/9/4/685/pdf"
  },
  {
    "id": "estrada-019",
    "title": "Power-Scaling Output-Compensated Three-Stage OTAs for Wide Load Range Applications",
    "authors": "Joseph Riad, Johan J. Estrada-López, Iván Padilla-Cantoya, Edgar Sánchez-Sinencio",
    "date": "2020-07-01",
    "type": "article",
    "venue": "IEEE Transactions on Circuits and Systems I: Regular Papers, vol. 67, no. 7, pp. 2180–2192",
    "doi": "https://doi.org/10.1109/TCSI.2020.2978515",
  },
  {
    "id": "estrada-020",
    "title": "Multiple-Input Harvesting Power Management Unit With Enhanced Boosting Scheme for IoT Applications",
    "authors": "Amr Abuellil, Johan J. Estrada-López, Aditya Bommireddipalli, Alfredo Costilla-Reyes, Zizhen Zeng, Edgar Sánchez-Sinencio",
    "date": "2020-05-01",
    "type": "article",
    "venue": "IEEE Transactions on Industrial Electronics, vol. 67, no. 5, pp. 3662–3672",
    "doi": "https://doi.org/10.1109/TIE.2019.2920607",
    "abstract": "PMU que extrae energía de cuatro fuentes con MPPT independiente por cosechador y una técnica de razón de elevación que mejora 3.5× el tiempo de carga. Detecta digitalmente el flujo de energía para reducir consumo en sequías energéticas y arranca en frío desde 0.4 V. Chip CMOS 180 nm (0.46 mm²), 2.6 mW máx. y 70% de eficiencia extremo a extremo."
  },
  {
    "id": "estrada-021",
    "title": "A Fully Integrated Maximum Power Tracking Combiner for Energy Harvesting IoT Applications",
    "authors": "Johan J. Estrada-López, Amr Abuellil, Alfredo Costilla-Reyes, Mohamed Abouzied, Sungjun Yoon, Edgar Sánchez-Sinencio",
    "date": "2020-04-01",
    "type": "article",
    "venue": "IEEE Transactions on Industrial Electronics, vol. 67, no. 4, pp. 2744–2754",
    "doi": "https://doi.org/10.1109/TIE.2019.2907449",
    "abstract": "Sistema totalmente integrado que combina la energía de cuatro entradas: selecciona automáticamente las dos de mayor potencia, las combina con seguimiento de máxima potencia y usa un esquema de almacenamiento bidireccional para aprovechar las otras dos. CMOS 0.13 µm; eficiencia de seguimiento pico 96% y de conversión 87.2% a 198 µW."
  },
  {
    "id": "estrada-022",
    "title": "A Reconfigurable Rectifier With Optimal Loading Point Determination for RF Energy Harvesting From −22 dBm to −2 dBm",
    "authors": "Zizhen Zeng, Johan J. Estrada-López, Mohamed A. Abouzied, Edgar Sánchez-Sinencio",
    "date": "2020-01-01",
    "type": "article",
    "venue": "IEEE Transactions on Circuits and Systems II: Express Briefs, vol. 67, no. 1, pp. 87–91",
    "doi": "https://doi.org/10.1109/TCSII.2019.2899338",
  },
  {
    "id": "estrada-023",
    "title": "Classification and Design Space Exploration of Low-Power Three-Stage Operational Transconductance Amplifier Architectures for Wide Load Ranges",
    "authors": "Joseph Riad, Johan J. Estrada-López, Edgar Sánchez-Sinencio",
    "date": "2019-11-01",
    "type": "article",
    "venue": "Electronics (MDPI), vol. 8, no. 11, art. 1268",
    "doi": "https://doi.org/10.3390/electronics8111268",
    "abstract": "Revisión y clasificación de arquitecturas de OTA de tres etapas y sus técnicas de compensación para amplios rangos de carga; propone una nueva figura de mérito para compararlas, respaldada con simulaciones a nivel transistor.",
    "tags": [
      "three-stage OTA",
      "Miller compensation",
      "nested Miller compensation",
      "reverse nested Miller compensation",
      "wide load range"
    ],
    "publicAccessUrl": "https://www.mdpi.com/2079-9292/8/11/1268",
    "pdfUrl": "https://www.mdpi.com/2079-9292/8/11/1268/pdf"
  },
  {
    "id": "estrada-025",
    "title": "Reconfigurable System for Electromagnetic Energy Harvesting With Inherent Activity Sensing Capabilities for Wearable Technology",
    "authors": "Alfredo Costilla-Reyes, Amr Abuellil, Johan J. Estrada-López, Salvador Carreón-Bautista, Edgar Sánchez-Sinencio",
    "date": "2019-08-01",
    "type": "article",
    "venue": "IEEE Transactions on Circuits and Systems II: Express Briefs, vol. 66, no. 8, pp. 1302–1306",
    "doi": "https://doi.org/10.1109/TCSII.2018.2884613",
  },
  {
    "id": "estrada-026",
    "title": "Multiple Input Energy Harvesting Systems for Autonomous IoT End-Nodes",
    "authors": "Johan J. Estrada-López, Amr Abuellil, Zizhen Zeng, Edgar Sánchez-Sinencio",
    "date": "2018-03-03",
    "type": "article",
    "venue": "Journal of Low Power Electronics and Applications (MDPI), vol. 8, no. 1, art. 6",
    "doi": "https://doi.org/10.3390/jlpea8010006",
    "abstract": "Revisión del diseño de unidades de gestión de potencia de ultra bajo consumo para nodos IoT, enfocada en arquitecturas para cosechar energía de múltiples fuentes heterogéneas; compara trabajos publicados y señala áreas abiertas de investigación.",
    "tags": [
      "energy harvesting",
      "multiple input",
      "Internet of Things"
    ],
    "publicAccessUrl": "https://www.mdpi.com/2079-9268/8/1/6",
    "pdfUrl": "https://www.mdpi.com/2079-9268/8/1/6/pdf"
  },
  {
    "id": "estrada-028",
    "title": "Experimental performance analysis of a CMOS amplifier considering different layout techniques",
    "authors": "Francisco López-Huerta, Johan J. Estrada-López, Agustín L. Herrera-May, et al. (incl. Carlos Zúñiga-Islas, Mónico Linares-Aranda)",
    "date": "2014",
    "type": "article",
    "venue": "Analog Integrated Circuits and Signal Processing (Springer), vol. 78, no. 3, pp. 799–806",
    "doi": "https://doi.org/10.1007/s10470-013-0202-z",
    "abstract": "Evalúa un amplificador CMOS clase AB implementado con tres estilos de layout (serpentina, concéntrico e interdigitado). El layout en serpentina redujo ~64% el área y ~39% el consumo frente al layout convencional.",
    "tags": [
      "CMOS amplifier",
      "Integrated circuits",
      "Layout techniques",
      "Systems on chip"
    ],
    "pdfUrl": "https://inaoe.repositorioinstitucional.mx/jspui/bitstream/1009/2315/1/144.%20Experimental%20Performance%20Analysis%20of%20a%20CMOS%20Amplifier%20Considering%20Different%20Layout%20Techniques.pdf"
  },
  {
    "id": "estrada-029",
    "title": "An Integrated ISFET pH Microsensor on a CMOS Standard Process",
    "authors": "Francisco López-Huerta, Rosa M. Woo-García, Miguel Lara-Castro, Johan J. Estrada-López, Agustín L. Herrera-May",
    "date": "2013",
    "type": "article",
    "venue": "Journal of Sensor Technology (SCIRP), vol. 3, no. 3",
    "doi": "https://doi.org/10.4236/jst.2013.33010",
  },
  {
    "id": "estrada-030",
    "title": "Study and comparison of CMOS layouts for applications in analog circuits",
    "authors": "Francisco López-Huerta, Johan J. Estrada-López, Mónico Linares-Aranda, Carlos Zúñiga-Islas, Blanca S. Soto-Cruz",
    "date": "2012-04-01",
    "type": "article",
    "venue": "Journal of Scientific & Industrial Research (NISCAIR), vol. 71, no. 4, pp. 257–261",
    "abstract": "Compara layouts en serpentina, concéntrico e interdigitado para un amplificador diferencial en CMOS 0.6 µm; la serpentina mejora 6–7 parámetros eléctricos, con −64% de área y −57% de consumo frente al layout convencional.",
    "tags": [
      "Integrated circuit (IC)",
      "Layout",
      "Operational amplifier",
      "Serpentine"
    ],
    "publicAccessUrl": "https://inaoe.repositorioinstitucional.mx/jspui/handle/1009/2124",
    "pdfUrl": "https://inaoe.repositorioinstitucional.mx/jspui/bitstream/1009/2124/1/71%20Zu%c3%b1iga_2012_ScientificIndustrial71.pdf"
  },
  {
    "id": "estrada-031",
    "title": "Alternative Post-Processing on a CMOS Chip to Fabricate a Planar Microelectrode Array",
    "authors": "Francisco López-Huerta, Agustín L. Herrera-May, Johan J. Estrada-López, Carlos Zuñiga-Islas, Blanca Cervantes-Sanchez, Enrique Soto, Blanca S. Soto-Cruz",
    "date": "2011-11-22",
    "type": "article",
    "venue": "Sensors (MDPI), vol. 11, no. 11, pp. 10940–10957",
    "doi": "https://doi.org/10.3390/s111110940",
    "abstract": "Post-proceso alternativo de un chip CMOS para liberar un arreglo plano de microelectrodos protegiendo su circuitería de lectura; usa silicio p+ como transductor de interfaz con neuronas. El amplificador y filtro integrados (98 kHz de ancho de banda, CMRR 87 dB) permitieron registrar neuronas vestibulares en cultivo.",
    "tags": [
      "CMOS chip",
      "microelectrode array",
      "CMOS post-process",
      "vestibular ganglion neurons"
    ],
    "publicAccessUrl": "https://www.mdpi.com/1424-8220/11/11/10940",
    "pdfUrl": "https://www.mdpi.com/1424-8220/11/11/10940/pdf"
  },
  {
    "id": "estrada-034",
    "title": "A Live Scoreboard for Surfing: Tracking Critical Surfing Maneuvers With Wearable Technology",
    "authors": "D. Rubin, Johan J. Estrada-López, W. Allison",
    "date": "2022-09-30",
    "type": "conference-paper",
    "venue": "2022 IEEE MIT Undergraduate Research Technology Conference (URTC), Massachusetts",
  },
  {
    "id": "estrada-035",
    "title": "Assessing Distinctives of the New Westmont Engineering Program in Terms of Their Impact on Recruitment, Student Satisfaction and Employment Potential",
    "authors": "D. Jensen, W. Jensen, Johan J. Estrada-López, D. Fontes, A. D. Goodworth",
    "date": "2022",
    "type": "conference-paper",
    "venue": "American Society for Engineering Education (ASEE)"
  },
  {
    "id": "estrada-036",
    "title": "Square-Wave-Based Multi-Tone Generator for Sleep-Improving Brain Stimulation",
    "authors": "Guillermo G. Garayar-Leyva, Johan J. Estrada-López, Oscar Moreira-Tamayo",
    "date": "2021-08-01",
    "type": "conference-paper",
    "venue": "2021 IEEE International Midwest Symposium on Circuits and Systems (MWSCAS), pp. 133–136",
    "doi": "https://doi.org/10.1109/MWSCAS47672.2021.9531755",
  },
  {
    "id": "estrada-037",
    "title": "A Harmonic-Canceling Synthesizer using Skew-Circulant-Matrix-Based Coefficient Generator",
    "authors": "Guillermo G. Garayar-Leyva, Hatem Osman, Johan J. Estrada-López, Edgar Sánchez-Sinencio",
    "date": "2020-10-01",
    "type": "conference-paper",
    "venue": "2020 IEEE International Symposium on Circuits and Systems (ISCAS), Sevilla, pp. 1–5",
    "doi": "https://doi.org/10.1109/ISCAS45731.2020.9181146",
  },
  {
    "id": "estrada-038",
    "title": "An Ultra-low-power Power Management Circuit with Output Bootstrapping and Reverse Leakage Reduction Function for RF Energy Harvesting",
    "authors": "Zizhen Zeng, Shanpu Shen, Bo Wang, Johan J. Estrada-López, Ross Murch, Edgar Sánchez-Sinencio",
    "date": "2020-08-01",
    "type": "conference-paper",
    "venue": "2020 IEEE/MTT-S International Microwave Symposium (IMS)",
  },
  {
    "id": "estrada-039",
    "title": "Technology Enabling Circuits and Systems for the Internet-of-Things: An Overview",
    "authors": "Johan J. Estrada-López, Amr Abuellil, Alfredo Costilla-Reyes, Edgar Sánchez-Sinencio",
    "date": "2018-05-01",
    "type": "conference-paper",
    "venue": "2018 IEEE International Symposium on Circuits and Systems (ISCAS), Florencia, pp. 1–5",
    "doi": "https://doi.org/10.1109/ISCAS.2018.8351876",
    "abstract": "Panorama de los circuitos y sistemas habilitadores del IoT: arquitectura de nodos sensores y el papel de la cosecha de energía para extender su autonomía (reimpreso parcialmente en el Cap. 2 de la tesis doctoral)."
  },
  {
    "id": "estrada-043",
    "title": "Distribución de la Densidad de Corriente e Impedancia de Materiales Alternativos en Microelectrodos Mediante el análisis de Elemento Finito",
    "authors": "Francisco López-Huerta, Johan J. Estrada-López, Leobardo Herrera-May, Carlos Zúñiga-Islas, Susana Soto-Cruz",
    "date": "2011-05-16",
    "type": "conference-paper",
    "venue": "V Congreso Latinoamericano de Ingeniería Biomédica (CLAIB 2011), La Habana — IFMBE Proceedings vol. 33, Springer",
    "doi": "https://doi.org/10.1007/978-3-642-21198-0_248",
  },
  {
    "id": "estrada-044",
    "title": "Design of an Integrated CMOS Instrumentation Amplifier for Biomedical Applications",
    "authors": "Rosa M. Woo-García, Francisco López-Huerta, Blanca S. Soto-Cruz, Johan J. Estrada-López",
    "date": "2010-10-26",
    "type": "conference-paper",
    "venue": "1st International Congress on Instrumentation and Applied Sciences, Cancún",
  },
  {
    "id": "estrada-045",
    "title": "Avances del Instituto Tecnológico de Mérida en la Enseñanza e Investigación en Microelectrónica",
    "authors": "Johan J. Estrada-López, Ramón Atoche-Enseñat",
    "date": "2008-02-20",
    "type": "conference-paper",
    "venue": "14th International Workshop Iberchip (IWS-2008), Puebla",
  },
  {
    "id": "estrada-046",
    "title": "A Low-Cost Interferential Current Stimulator for Physical Therapy",
    "authors": "A. Collí-Menchi, J. Efraín Gaxiola-Sosa, H. Pinto-Ávila, Johan J. Estrada-López",
    "date": "2007-03-14",
    "type": "conference-paper",
    "venue": "13th International Workshop Iberchip (IWS-2007), Lima",
  },
  {
    "id": "estrada-047",
    "title": "Introducing Digital IC Design and Test to Undergraduate Students",
    "authors": "Johan J. Estrada-López, Federico Sandoval-Ibarra",
    "date": "2006-03-22",
    "type": "conference-paper",
    "venue": "12th International Workshop Iberchip (IWS-2006), San José, Costa Rica",
  },
  {
    "id": "estrada-048",
    "title": "Ethernet/Internet Control of Modular Production Systems with Embedded Microcontrollers",
    "authors": "Alejandro Castillo-Atoche, Javier Vázquez-Castillo, Ramón Atoche-Enseñat, Johan J. Estrada-López",
    "date": "2006-03-22",
    "type": "conference-paper",
    "venue": "12th International Workshop Iberchip (IWS-2006), San José, Costa Rica",
  },
  {
    "id": "estrada-049",
    "title": "Inicialización Automática de Pose: Nuevos Resultados Utilizando FPGA's para el Registro y Apareamiento del Modelo",
    "authors": "Ramón Atoche-Enseñat, L. A. Muñoz-Ubando, A. Sebastiá-Cortés, Johan J. Estrada-López",
    "date": "2006-03-22",
    "type": "conference-paper",
    "venue": "12th International Workshop Iberchip (IWS-2006), San José, Costa Rica",
  },
  {
    "id": "estrada-051",
    "title": "Circuits and Systems for Energy Harvesting and Internet of Things Applications",
    "authors": "Johan Jair Estrada López",
    "date": "2019-05-01",
    "type": "thesis-doctoral",
    "venue": "PhD Dissertation, Electrical Engineering, Texas A&M University",
    "abstract": "Aborda la vida útil limitada de dispositivos IoT con batería mediante cosecha de energía. Parte 1: sistema totalmente integrado de gestión de potencia que combina múltiples cosechadores (incluye MPPT combiner y SECE piezoeléctrico multientrada). Parte 2: nodos sensores de bajo consumo para agricultura de precisión, incluido un prototipo termoeléctrico solar.",
    "publicAccessUrl": "https://oaktrust.library.tamu.edu/",
    "pdfUrl": "https://oaktrust.library.tamu.edu/server/api/core/bitstreams/fcc1688d-08ee-470a-b560-c1a6e0ba01be/content"
  },
  {
    "id": "estrada-052",
    "title": "Design of a 1.5-GHz Low-Noise Amplifier in 0.6-μm Technology",
    "authors": "Johan J. Estrada-López",
    "date": "2003",
    "type": "thesis-masters",
    "venue": "Tesis de maestría, CINVESTAV-IPN, Guadalajara",
  }
];
